import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Connect',
    component: () => import('../views/ConnectPage.vue')
  },
  {
    path: '/Transfer',
    name: 'Transfer',
    component: () => import('../views/TransferPage.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
